import { render, staticRenderFns } from "./ApexBarsChart.vue?vue&type=template&id=66971b90"
import script from "./ApexBarsChart.vue?vue&type=script&lang=js"
export * from "./ApexBarsChart.vue?vue&type=script&lang=js"
import style0 from "./ApexBarsChart.vue?vue&type=style&index=0&id=66971b90&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports